const allImages = {
  'iPhone 17': [
    ['Lavender', require('../assets/images/thumbnails/iphone17-lavender.png')],
    [
      'Mist Blue',
      require('../assets/images/thumbnails/iphone17-mist-blue.png')
    ],
    ['Sage', require('../assets/images/thumbnails/iphone17-sage.png')],
    ['White', require('../assets/images/thumbnails/iphone17-white.png')],
    ['Black', require('../assets/images/thumbnails/iphone17-black.png')]
  ],
  'iPhone Air': [
    ['Sky Blue', require('../assets/images/thumbnails/iphoneair-sky-blue.png')],
    [
      'Light Gold',
      require('../assets/images/thumbnails/iphoneair-light-gold.png')
    ],
    [
      'Cloud White',
      require('../assets/images/thumbnails/iphoneair-cloud-white.png')
    ],
    [
      'Space Black',
      require('../assets/images/thumbnails/iphoneair-space-black.png')
    ]
  ],
  'iPhone 17 Pro': [
    [
      'Cosmic Orange',
      require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png')
    ],
    [
      'Deep Blue',
      require('../assets/images/thumbnails/iphone17pro-deep-blue.png')
    ],
    ['Silver', require('../assets/images/thumbnails/iphone17pro-silver.png')]
  ],
  'iPhone 17 Pro Max': [
    [
      'Cosmic Orange',
      require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    ],
    [
      'Deep Blue',
      require('../assets/images/thumbnails/iphone17promax-deep-blue.png')
    ],
    ['Silver', require('../assets/images/thumbnails/iphone17promax-silver.png')]
  ]
};

function createDeviceImageConfig(deviceName) {
  const allDeviceImages = allImages[deviceName];
  return allDeviceImages.map(([colour, src]) => ({
    name: deviceName,
    colour,
    src
  }));
}

const modelRanking = [
  {
    name: 'iPhone 17 Pro Max',
    colours: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    sizes: ['1TB', '2TB', '256GB', '512GB']
  },
  {
    name: 'iPhone 17 Pro',
    colours: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    sizes: ['256GB', '512GB', '1TB']
  },
  {
    name: 'iPhone Air',
    colours: ['Space Black', 'Cloud White', 'Light Gold', 'Sky Blue'],
    sizes: ['256GB', '512GB', '1TB']
  },
  {
    name: 'iPhone 17',
    colours: ['Sage', 'Lavender', 'Mist Blue', 'White', 'Black'],
    sizes: ['256GB', '512GB']
  }
];

const modelRankingPresales = [
  {
    name: 'iPhone 17',
    colours: ['Sage', 'White' , 'Lavender', 'Mist Blue', 'Black'],
    sizes: ['512GB','256GB']
  },  
  {
    name: 'iPhone 17 Pro Max',
    colours: ['Deep Blue' , 'Cosmic Orange', 'Silver'],
    sizes: ['512GB' , '1TB', '2TB', '256GB']
  },
  {
    name: 'iPhone 17 Pro',
    colours: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    sizes: ['256GB', '512GB', '1TB']
  },
  {
    name: 'iPhone Air',
    colours: ['Cloud White', 'Light Gold', 'Sky Blue', 'Space Black'],
    sizes: ['1TB' , '256GB', '512GB']
  }
];

export const productSelectionRanking = {
  models: modelRanking
};

export const productSelectionRankingiphone17presales = {
  models: modelRankingPresales
}

export const devices = {
  iphone17: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17internal: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17test1: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17test2: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  mercbrt: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17presales1: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking: productSelectionRankingiphone17presales,
    presale: true
  },
  iphone17presales2: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking: productSelectionRankingiphone17presales,
    presale: true
  },
  iphone17presalesBRT: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking,
    presale: true
  },
  iphone17test3: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17maxbrt: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking,
    presale: true
  },
  iphone17probrt: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    productSelectionRanking
  },
  iphone17roibrt1: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    preSelectModel: 'iPhone 17 Pro Max|Cosmic Orange|1TB'
  },
  iphone17presalesbrt1: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    preSelectModel: 'iPhone 17 Pro Max|Cosmic Orange|1TB'
  },
  iphone17probrtROI: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    preSelectModel: 'iPhone 17 Pro Max|Cosmic Orange|1TB'
  },
  iphone17maxbrtPresales: {
    name: 'iPhone 17',
    description: 'iPhone 17',
    devices: {
      'iPhone 17': require('../assets/images/thumbnails/iphone17-lavender.png'),
      'iPhone Air': require('../assets/images/thumbnails/iphoneair-sky-blue.png'),
      'iPhone 17 Pro': require('../assets/images/thumbnails/iphone17pro-cosmic-orange.png'),
      'iPhone 17 Pro Max': require('../assets/images/thumbnails/iphone17promax-cosmic-orange.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 17'),
      ...createDeviceImageConfig('iPhone Air'),
      ...createDeviceImageConfig('iPhone 17 Pro'),
      ...createDeviceImageConfig('iPhone 17 Pro Max')
    ],
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png'),
    preSelectModel: 'iPhone 17 Pro Max|Cosmic Orange|1TB'
  },
  default: {
    banner: require('../assets/images/banners/banner_iphone17_mass_800x400.png')
  },
  allImages: []
};

export const defaultDevice = Object.keys(devices)[0];
